module.exports = ".row{\r\n    padding:1em 0px 0px;\r\n}\r\n\r\n.row:nth-child(odd){\r\n    background: #f2f2f2;\r\n}\r\n\r\n@media (min-width: 992px){\r\n    .modal-lg {\r\n        max-width: 1320px;        \r\n    }\r\n}\r\n\r\n.border-box{\r\n    border: 1px solid #2196F3;\r\n    padding: 1px 16px;\r\n}\r\n\r\n#lNewModel .table-responsive {\r\n    padding: 10px;\r\n    margin-top: -15px;\r\n    margin-bottom: -20px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/landprocurement/land-rec-details/landrec-form/landrec-form.component.css
// module id = ./src/app/landprocurement/land-rec-details/landrec-form/landrec-form.component.css
// module chunks = main